/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SafetyNetValidateAttestationRequest} from '@cash-web/protos/squareup/client/flipper/flipper.pb'
import {SafetyNetValidateAttestationResponse} from '@cash-web/protos/squareup/client/flipper/flipper.pb'


export const safetyNetValidateAttestation = (request: SafetyNetValidateAttestationRequest, options?: CashRequestOptions) => post<SafetyNetValidateAttestationRequest, SafetyNetValidateAttestationResponse>("/2.0/cash/safety-net-validate-attestation", request, {...options, rejectOnError: true })